import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { LogService } from "src/app/services/logging/log.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class AuthService implements CanActivate {
  constructor(private router: Router, private logger: LogService, private http: HttpClient) {}

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const url: string = state.url;
    this.logger.info(`Routing to ${url}`);

    if (!url.includes("/external")) {
      console.log("redirecting to login page");
      this.router.navigate(["general"]);
      return false;
    }

    return true;
  }
}
